import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 0 30px 0;
  max-width: 1400px;
  margin: 0 auto;
`

export const Header = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 24px;
  width: 100%;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
`

export const CompetencesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`
